module.exports = __webpack_public_path__ + "690e10d69c876ccd03c58d7673d9ffa3.svg";